<div class="novo-tabs">
  <div class="novo-tabs__header">
    <button
      *ngFor="let tab of tabs"
      #tabButton
      type="button"
      class="novo-tabs__tab"
      [class.novo-tabs__tab--active]="activeTab === tab.value"
      (click)="setActiveTab(tab.value)"
    >
      <i *ngIf="tab.icon" [class]="tab.icon"></i>
      {{ tab.label }}
    </button>
    <div class="novo-tabs__indicator" [ngStyle]="indicatorStyle"></div>
  </div>

  <div class="novo-tabs__content">
    <ng-content></ng-content>
  </div>
</div>
